let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hGSL3")).then(() => parcelRequire('jOGWx'));